import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as businessUserRolesState from '../auth.reducer';
import * as businessUserRolesReducer from '../reducers/business-user-role.reducer';

export const selectBusinessUserRole = createSelector(
  businessUserRolesState.getBusinessUserRolesState,
  businessUserRolesReducer.getBusinessUserRoles
);

export const selectUserPermissions = createSelector(
  businessUserRolesState.getBusinessUserRolesState,
  (state) => state?.permissions || []
);

export const selectLegalEntityPermissions = createSelector(
  businessUserRolesState.getBusinessUserRolesState,
  (state) => state?.legalEntityPermissions
);

export const selectCurrentLegalEntityId = createSelector(
  businessUserRolesState.getBusinessUserRolesState,
  (state) => state?.currentLegalEntityId
);